import { render, staticRenderFns } from "./DetailsInput.vue?vue&type=template&id=30578ff5&scoped=true"
import script from "./DetailsInput.vue?vue&type=script&lang=js"
export * from "./DetailsInput.vue?vue&type=script&lang=js"
import style0 from "./DetailsInput.vue?vue&type=style&index=0&id=30578ff5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30578ff5",
  null
  
)

export default component.exports